<ion-content class="image-backdrop" fullscreen>
  <ion-item class="close-fake ion-text-center" lines="none">

    <div class="col-11 d-flex justify-content-start">
      <ion-button (click)="zoom(true)" fill="clear" color="light">
        <fa-icon [icon]="faSearchPlus"></fa-icon>
        <!-- <ion-icon name="add" slot="start"></ion-icon> -->
      </ion-button>

      <ion-button (click)="zoom(false)" fill="clear" color="light">
        <!-- <ion-icon name="remove" slot="start"></ion-icon> -->
        <fa-icon [icon]="faSearchMinus"></fa-icon>
      </ion-button>
    </div>
    <div class="col-1">
      <ion-button class="" (click)="close()" fill="clear" color="light">
        <fa-icon [icon]="faTimes"></fa-icon>
      </ion-button>
    </div>
  </ion-item>

  <swiper-container class="swiper-el" init="false" [autoHeight]="false" [allowTouchMove]="true" [pagination]="{ clickable: true }"
    [navigation]="true" [zoom]="sliderOpts.zoom" [loop]="imagesArr.length > 1" #swiper>
    <swiper-slide *ngFor="let img of imagesArr">
      <div class=" program-image-wrap-el swiper-zoom-container">
        <img class="program-image-el" [src]="img.Key" />
      </div>
    </swiper-slide>
  </swiper-container>

</ion-content>
